module.exports = __webpack_public_path__ + "static/media/video_thumb3.a26bda41.svg";